/**
 * String catalog registry. Import a catalog lazily when the resolver
 * picks a non-English locale. English is always available as fallback.
 *
 * Adding a locale:
 *   1. Drop in strings/<code>.ts that exports `strings: StringCatalog`.
 *   2. Set `ready: true` in locales.ts for that code.
 *   3. Add a case to `loadCatalog` below.
 *
 * That's it — picker and fallback all Just Work.
 */

import type { LocaleCode } from '../locales'
import en, { type StringCatalog } from './en'
import he from './he'

const LOADED: Partial<Record<LocaleCode, StringCatalog>> = {
  en,
  he,
}

export async function loadCatalog(code: LocaleCode): Promise<StringCatalog> {
  if (LOADED[code]) return LOADED[code] as StringCatalog
  // Future lazy loaders:
  //   if (code === 'fr') { const m = await import('./fr'); LOADED.fr = m.default; return m.default }
  return en
}

/** Synchronous accessor — safe only for locales already loaded. */
export function getCatalog(code: LocaleCode): StringCatalog {
  return (LOADED[code] as StringCatalog) || en
}

export type { StringCatalog }
export { en, he }
